import buildUrl from 'modules/core/lib/buildUrl'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

export const getMemberAvatars = (ownerAccessIds: number[]) => {
  const members = users.filter((user) => ownerAccessIds.includes(user.id))

  const avatarStack = members.map((member) => {
    return {
      label: getFullDisplayName({
        firstName: member.attributes.first_name,
        lastName: member.attributes.last_name,
      }),
      url: buildUrl(member.avatar_full),
    }
  })

  return avatarStack
}
